import convertNumberToCurrencyString from './convertNumberToCurrencyString';

export default convertNumberToCurrencyString;
